"use client";

import { useContext } from "react";
import { FilterParamsContext } from "../FilterParamsProvider";
import ValueSlider from "../ValueSlider";

export const CITY_POPULATION_MAX_VALUE = 10000000;
export const COUNTY_POPULATION_MAX_VALUE = 20000000;

export const sliderValueToFilterValue = (value: number) => {
  if (value === 0) {
    return 0;
  } else {
    const leadingNumber = ((value - 1) % 9) + 1;
    return leadingNumber * 100 * 10 ** Math.ceil(value / 9); // minimum 1000
  }
};

export const filterValueToSliderValue = (
  fallbackValue: number,
  value?: number,
) => {
  if (value === undefined || value === null || value === -1) {
    return fallbackValue;
  } else if (value === 0) {
    return 0;
  } else {
    // this is the inverse of sliderValueToFilterValue
    const leadingNumber = parseInt(value.toString()[0]);
    const ceil = (Math.log10(value / leadingNumber) - 2) * 9;
    return ceil - 9 + leadingNumber;
  }
};

export default function PopulationSlider({
  label,
  filterType,
}: {
  filterType: "city_population" | "county_population";
  label: string;
}) {
  const { setFilterParams, filterParams } = useContext(FilterParamsContext);
  const max =
    filterType === "city_population"
      ? CITY_POPULATION_MAX_VALUE
      : COUNTY_POPULATION_MAX_VALUE;

  return (
    <ValueSlider
      label={label}
      value={filterParams[filterType]}
      onChange={(newValue) =>
        setFilterParams({
          ...filterParams,
          [filterType]: newValue,
        })
      }
      sliderValueToFilterValue={sliderValueToFilterValue}
      filterValueToSliderValue={filterValueToSliderValue}
      max={max}
    />
  );
}
